export const usersTable = [
    {
        key: 'user',
        value: 'title',
        link: true,
    },
    {
        key: 'count_of_pass',
        value: 'count',
    },
    {
        key: 'average_point',
        value: 'average_points',
    },
];

export const questionsTable= [
    {
        key: 'question_text',
        value: 'plain_text',
        link: true,
    },
    {
        key: 'try_count',
        value: 'answer_count',
    },
    {
        key: 'average_point',
        value: 'average_points',
    },
];

export const usersForQuestionsTable = [
    {
        key: 'user',
        value: 'title',
        link: true,
    },
    {
        key: 'try_count',
        value: 'count',
    },
    {
        key: 'average_point',
        value: 'average_points',
    },
];

export const userSessionsTable = [
    {
        key: 'session_date',
        value: 'date',
        link: true,
    },
    {
        key: 'questions_count',
        value: 'questions_count',
        description_key: 'questions_count_description',
    },
    {
        key: 'total_points',
        value: 'total_points',
        description_key: 'total_points_description',
    },
    {
        key: 'average_point',
        value: 'average_points',
    },
];

